module.exports = __webpack_public_path__ + "img/DK24255816.b904e2eb.png";